import React from 'react'
import footerlogo from '../../assets/footer-logo.svg'
import { Link } from 'react-router-dom'

const Footer = () => {
    const scrollToTop = () => window.scrollTo(0, 0);

    return (
        <div class="flex items-end w-full bg-white">
            <footer class="w-full text-gray-700 bg-footer-bg body-font bg-center bg-cover">
                <div class="container flex flex-col flex-wrap px-5 py-14 mx-auto md:items-center lg:items-start md:flex-row md:flex-no-wrap">
                    <div class="flex-shrink-0 w-64 mx-auto text-center bg-covers md:mx-0 md:text-left">
                        <Link to="/" onClick={scrollToTop} class="flex items-center justify-start font-medium text-gray-900 title-font md:justify-start">
                            <img src={footerlogo} alt="Xtasy logo" />
                        </Link>
                    </div>
                    <div class="flex flex-wrap flex-grow mt-10 -mb-10 text-center md:pl-20 md:mt-0 md:text-left">
                        <div class="w-full px-4 lg:w-1/3 md:w-1/2">
                            <h2 class="mb-3 font-medium tracking-widest text-gray-900 uppercase title-font text-sm  ">RESOURCES</h2>
                            <nav class="mb-10 list-none font-medium">
                                <li class="mt-3">
                                    <Link to="/"
                                        class="text-gray-500 cursor-pointer hover:text-gray-900 text-xs"
                                        onClick={scrollToTop}>ABOUT</Link>
                                </li>
                                <li class="mt-3">
                                    <Link to="/events"
                                        class="text-gray-500 cursor-pointer hover:text-gray-900 text-xs"
                                        onClick={scrollToTop}>EVENTS</Link>
                                </li>
                                <li class="mt-3">
                                    <Link to="/pronite"
                                        class="text-gray-500 cursor-pointer hover:text-gray-900 text-xs"
                                        onClick={scrollToTop}>PRONITE</Link>
                                </li>
                                <li class="mt-3">
                                    <Link to="/team"
                                        class="text-gray-500 cursor-pointer hover:text-gray-900 text-xs"
                                        onClick={scrollToTop}>TEAM</Link>
                                </li>
                            </nav>
                        </div>

                        <div class="w-full px-4 lg:w-1/3 md:w-1/2">
                            <h2 class="mb-3 text-sm font-medium tracking-widest text-gray-900 uppercase title-font ">Platform
                            </h2>
                            <nav class="mb-10 list-none">
                                <li class="mt-3">
                                    <Link to="/register"
                                        class="text-gray-500 cursor-pointer hover:text-gray-900 text-xs"
                                        onClick={scrollToTop}>Sign Up</Link>
                                </li>
                            </nav>
                        </div>
                        <div class="w-full px-4 lg:w-1/3 md:w-1/2">
                            <h2 class="mb-3 text-sm font-medium tracking-widest text-gray-900 uppercase title-font">Follow us
                            </h2>

                            <div class="mt-4">
                                <span class="inline-flex justify-center mt-2 sm:ml-auto sm:mt-0 sm:justify-start">

                                    <a class="ml-3 text-gray-500 cursor-pointer hover:text-gray-700" href="https://www.instagram.com/xtasy_bvcoe/">
                                        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                            <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                                            <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
                                        </svg>
                                    </a>

                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            </footer>

        </div>
    )
}

export default Footer
